import type { ComboboxOption } from '@standardsdigital/ui-components/Combobox';

export const messageSeverity = (message?: string) =>
  message ? 'danger' : 'neutral';

export const addSelectedValue = <T>(selectedValues: T[], value: T): T[] =>
  selectedValues.includes(value) ? selectedValues : [...selectedValues, value];

export const removeSelectedValues = (
  selectedValues: string[],
  optionsToRemove: ComboboxOption[],
): string[] =>
  selectedValues.filter(
    (value) => !optionsToRemove.some((option) => option.value === value),
  );

export const removeNumberValues = (
  selectedValues: number[],
  optionsToRemove: ComboboxOption[],
): number[] =>
  selectedValues.filter(
    (value) => !optionsToRemove.some((option) => Number(option.value) === value),
  );
